
import Injection = EECore.Injection;
import DocumentModel from "../../components/models/documentCentre/documentModel";
import { WidgetResources } from "../../resources/widget";

@Injection.injectableClass("DocumentCentreDocumentService")
export default class DocumentService {

  @Injection.injectableProperty("DocumentCentreDocumentService", EECore.Registrations.HTTP_CLIENT)
  private httpClient: EECore.HttpClient;

  @Injection.injectableProperty("DocumentCentreDocumentService", "WidgetResources")
  private resources: WidgetResources;

  constructor(httpClient: EECore.HttpClient, resources: WidgetResources) {
    this.httpClient = httpClient;
    this.resources = resources;
  }
    
  getFavouriteDocuments(): EECore.Promise<DocumentModel[], string> {
    return new EECore.Promise<DocumentModel[], string>((resolve, reject) => {
      const request = this.httpClient.get<DocumentModel[]>("/wemwpn41/api/v2/documents/favourites", true);
      request.then((documents: DocumentModel[]) => {
        if (documents.length === 0)
          reject(this.resources.documentCentre.favourites.noDocumentMessage);
        else
          resolve(documents);
      }).catch(() => {
        reject(this.resources.documentCentre.favourites.errorMessage);
      });
    });
  }

  removeFavouriteDocument(documentId: string) {
    if (!documentId) throw new Error("documentId is required");

    return new EECore.Promise<boolean, string>((resolve, reject) => {
      const request = this.httpClient.delete(`/wemwpn41/api/v2/documents/favourites/${documentId}`, true);
      request.then(() => {
        resolve(true);
      }).catch((message: string) => {
        reject(message);
      });
    });
  }

  moveFavouriteUp(documentId: string) {
    if (!documentId) throw new Error("documentId is required");

    return this.moveFavourite(documentId, "up");
  }

  moveFavouriteDown(documentId: string) {
    if (!documentId) throw new Error("documentId is required");

    return this.moveFavourite(documentId, "down");
  }

  private moveFavourite(documentId: string, direction: string) {
    return new EECore.Promise<boolean, string>((resolve, reject) => {
      const request = this.httpClient.put(`/wemwpn41/api/v2/documents/favourites/${documentId}/position`, { direction: direction }, true);
      request.then(() => {
        resolve(true);
      }).catch((message: string) => {
        reject(message);
      });
    });
  }

}